import { Axios } from 'src/class/Axios.js';

const mixinMainCrud = {
  watch: {
    '$i18n.locale': 'setupTable',
  },
  methods: {
    setupTable() {
      this.tableProperties = {
        ...this.tableProperties,
        ...this.buildTableProperties,
      };
    },
    notifyVue(data) {
      this.$emit('showNotification', data);
    },
    loadData() {
      this.showHideLoading(true);
      Axios.getMasters(this.getModuleRoute)
        .then((response) => {
          this.tableProperties = {
            ...this.buildTableProperties,
            data: response.data.data,
          };
          this.showHideLoading();

        })
        .catch((error) => this.showMessageErrors(error));
    },
    refresh(refresh = false) {
      if (!refresh) return Axios.getMasters(this.getModuleRoute);
      else this.loadData();
    },
    addEdit(dataModel) {
      this.$refs.masterMain.model = {
        ...dataModel,
        route: dataModel.isEdit ? this.getModuleRoute : null,
      };
      this.$refs.masterMain.addEdit();
    },
  },
  created() {
    if (this.isIndex()) this.loadData();

    else this.showHideLoading();
  },
};

export default mixinMainCrud;
